import axios from "axios";
// import { SET_PROXY_ID } from "./actionTypes";
import { RELOD_PHONEBOOKLIST } from "./actionTypes";

export const setRelodState = (relodState) => {
  // console.log("proxy action...", proxyId);
  return {
    type: RELOD_PHONEBOOKLIST,
    relodState: relodState,
  };
};
